// Apps Registry - Auto-generated for heston.developmentsnapshot.com
// This file is generated at deploy time for isolated single-app deployments

import * as JobsMonitor from './jobs-monitor';
import * as Heston from './heston';

// App registry - only includes apps for this deployment
export const appRegistry = {
  'jobs-monitor': {
    name: 'Jobs Monitor',
    description: 'Monitor DynamoDB Jobs System operations',
    category: 'Monitoring',
    icon: 'MONITOR',
    color: '#6f42c1',
    exports: JobsMonitor
  },
  'heston': {
    name: 'Heston',
    description: 'Pest control pricing simulator & analytics',
    category: 'Operations',
    icon: 'APP',
    color: '#2e7d32',
    exports: Heston
  }
};

// Helper to get all available apps as an array
export const getAvailableApps = () => {
  return Object.keys(appRegistry).map(id => ({
    id,
    ...appRegistry[id]
  }));
};

// Helper to get app exports by ID
export const getAppExports = (appId) => {
  return appRegistry[appId]?.exports || null;
};

// Helper to get the default app from deployment config
export const getDefaultApp = () => {
  return null;  // Determined by deployment config at runtime
};
